/* eslint-disable */

import instance from './frontman';

export const getBanner = async (accessToken?: String) => {
    return await instance({
        url: "/banner",
        method: "get"
    })
};